import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedProducts from './components/FeaturedProducts';
import WhySection from './components/WhySection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedProducts />
        <WhySection />
        <ArticlesSection />
        <FAQSection />
        <FinalCTASection />
      </main>

      <Footer />
    </div>
  );
}